import { setCookie } from "utils/cookies";

export const toggleSidebar = () => (dispatch, getState) => {
  const {
    sidebar: { is_open },
  } = getState();
  setCookie("pim_sidebar_open", !is_open);
  dispatch({ type: "SIDEBAR_TOGGLE" });
};
